class ShareButton extends HTMLElement {
  connectedCallback() {
    this.elements = {
      shareButton: this.querySelector('button'),
      successMessage: this.querySelector('[id^="ShareMessage"]'),
      urlInput: this.querySelector('input'),
      mainDetailsToggle: this.querySelector('details'),
    }

    this.onKeyUp = this.onKeyUp.bind(this)
    this.onFocusOut = this.onFocusOut.bind(this)
    this.toggleDetails = this.toggleDetails.bind(this)
    this.copyToClipboard = this.copyToClipboard.bind(this)

    this.addEventListener('keyup', this.onKeyUp)
    this.elements.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut
    )

    if (navigator.share) {
      this.elements.mainDetailsToggle.setAttribute('hidden', '')
      this.elements.shareButton?.classList.remove('hidden')
      this.elements.shareButton?.addEventListener('click', () => {
        navigator.share({ url: document.location.href, title: document.title })
      })
    } else {
      this.elements.mainDetailsToggle.addEventListener(
        'toggle',
        this.toggleDetails
      )
      this.elements.mainDetailsToggle
        .querySelector('hh-button')
        .addEventListener('click', this.copyToClipboard)
    }
  }

  disconnectedCallback() {
    this.removeEventListener('keyup', this.onKeyUp)
    this.elements.mainDetailsToggle.removeEventListener(
      'focusout',
      this.onFocusOut
    )

    if (!navigator.share) {
      this.elements.mainDetailsToggle.removeEventListener(
        'toggle',
        this.toggleDetails
      )
      this.elements.mainDetailsToggle
        .querySelector('hh-button')
        .removeEventListener('click', this.copyToClipboard)
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    const summaryElement = openDetailsElement.querySelector('summary')
    openDetailsElement.removeAttribute('open')
    summaryElement.focus()
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  close() {
    this.elements.mainDetailsToggle.removeAttribute('open')
  }

  toggleDetails() {
    if (!this.mainDetailsToggle.open)
      this.elements.successMessage.classList.add('hidden')
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
      this.elements.successMessage.classList.remove('hidden')
      this.elements.successMessage.setAttribute('aria-hidden', false)

      setTimeout(() => {
        this.elements.successMessage.setAttribute('aria-hidden', true)
      }, 6000)
    })
  }
}

customElements.define('share-button', ShareButton)
